module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword by James D. G. Dunn")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Beyond Belief")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s1"
    }
  }, [_vm._v("Faith as Opinion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s2"
    }
  }, [_vm._v("Faith as Doctrine")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s3"
    }
  }, [_vm._v("Faith as Passive")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s4"
    }
  }, [_vm._v("The Old Testament Foundation of Paul’s Use of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s5"
    }
  }, [_vm._v("Faith or Faithfulness?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s6"
    }
  }, [_vm._v("Is This a Book about the "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις Χριστοῦ")]), _vm._v(" (Faith of Christ) Debate?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s7"
    }
  }, [_c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" and the Divine and Human Agency in Paul Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s8"
    }
  }, [_vm._v("A Question of Method")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s9"
    }
  }, [_vm._v("Looking Ahead")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s10"
    }
  }, [_vm._v("How to Navigate This Book: A Note for Different Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Faith in Paul")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early and Medieval Use of Faith Language")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luther and Calvin on Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern Scholarship on Paul and Christian Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teresa Morgan’s "), _c('i', [_vm._v("Roman Faith and Christian Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" in Ancient Non-Jewish and Jewish Literature")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pagan Hellenistic Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellenistic Jewish Literature: Septuagint and Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellenistic Jewish Literature: Philo")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellenistic Jewish Literature: Josephus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Will He Find Faith on Earth?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repent and Believe: Faith Language in Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seek, Trust, and Obey: Faith Language in Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Will the Son of Man Find Faith on Earth? The Gospel of Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belief in the Gospel of John")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Faithfulness Is Better")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plutarch and Odysseus’s Silent Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Strange Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith Language in 1 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strange Wisdom, Humble Faith (2:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul and the Gift of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" (12:9; 13:2)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith, Hope, Love: Is Faith Eternal? (13:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space"
  }, [_vm._v("On Faith and Forms")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Corinthians and the Corinthian Situation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Theology of Idolatry")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Corinthians 4:1–5:10")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Covenantal Pistism")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" and the Quest for Paul’s Soteriology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covenantal Nomism or Covenantal “Pistism”?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" in Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christ-Relation in Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covenantal Pistism and the Agency Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space"
  }, [_vm._v("And the Righteous Will Live by Trust")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 1:16–17: A Brief Exegetical Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Background of Habakkuk 2:4 and Its Early Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whose "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trust, Faith, or Faithfulness? Translating and Interpreting "), _c('span', {
    staticClass: "heb"
  }, [_vm._v("אמונה")]), _vm._v(" and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" to "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Revisiting “The Faith of Christ”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Possible Readings of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις Χριστοῦ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις Χριστοῦ")]), _vm._v(" and the Centrality of the Christ-Relation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Translation Question")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Importance of Human Faith in the Christ-Relation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Faith beyond Belief")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obeying Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Believing Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trusting Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" as a Tensive Symbol in Early Christian Discourse")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Influences on Pauline "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Πίστις")]), _vm._v(" Language")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Has Works to Do with Faith?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine and Human Agency: Believing, Trusting, and Doing")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Did Christians Come to Be Called Believers?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Names and Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture and Other Ancient Texts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0